export default __webpack_public_path__ + "case-study-sum-up-section.png";